import React, { FC } from 'react';
import { RoleRestrictedProps } from './RoleRestrictedProps';
import { useTypedSelector } from '../../store';
import { selectUserRole } from '../../store/userData/selectors';
import { roleRestricted } from './utils';

const RoleRestricted: FC<RoleRestrictedProps> = ({
  roles,
  children,
  confidentialRestricted,
  confidentialLevel,
}) => {
  const userRole = useTypedSelector(selectUserRole);
  const roleAllowed = roleRestricted(roles, userRole);
  const confidentialAllowed = confidentialRestricted
    ? confidentialRestricted.includes(confidentialLevel)
    : true;
  return roleAllowed && confidentialAllowed ? <>{children}</> : null;
};

export default RoleRestricted;
